<template>
  <b-col
    :cols="colSize * 6"
    :sm="colSize * 4"
    :md="colSize * 2"
    :lg="colSize * 2"
    :xl="colSize"
  >
    <b-form-group :label="label" label-for="input" :label-cols="labelCols">
      <b-form-input
        v-bind:value="value"
        @blur.native="$emit('onBlur')"
        v-on:input="$emit('input', $event)"
        id="input"
        :disabled="disabled"
        :readonly="readonly"
        :placeholder="placeholder || label"
        :type="type || 'text'"
        :min="min"
        size="sm"
      >
      </b-form-input>
    </b-form-group>
  </b-col>
</template>

<script>
export default {
  name: 'filter-input',
  props: ['value', 'label', 'cols', 'disabled', 'labelCols', 'readonly', 'type', 'min', 'placeholder'],
  computed: {
    colSize: function() {
      return this.cols || 3;
    },
  },
};
</script>
